import { gql } from "@apollo/client";

const GET_CURRENT_USER_INFO = gql`
  query CurrentLevel {
    me {
      savedLevels {
        id
        languageId
      }
      currentLevel {
        id
      }
      spokenOnly
      preferClassType
      charactersPreference
      credits
      webcalUrl
      currentLanguage {
        id
        englishName
        realName
        levels {
          id
          title
        }
      }
      givenName
      email
    }
  }
`;

export default GET_CURRENT_USER_INFO;
